var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemSettingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 18.001,
    viewBox: "0 0 17.998 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_399",
    "data-name": "Union 399",
    d: "M6211.176,12116a.2.2,0,0,1-.2-.168l-.155-1.061a2.955,2.955,0,0,1-.7-.393l-1.025.4a.211.211,0,0,1-.25-.088l-.824-1.384a.2.2,0,0,1,.051-.256l.867-.662a2.542,2.542,0,0,1,0-.782l-.867-.659a.2.2,0,0,1-.051-.256l.824-1.387a.2.2,0,0,1,.25-.088l1.025.4a3.177,3.177,0,0,1,.7-.393l.155-1.061a.2.2,0,0,1,.2-.168h1.645a.2.2,0,0,1,.2.168l.158,1.061a3.087,3.087,0,0,1,.7.393l1.022-.4a.214.214,0,0,1,.252.088l.821,1.387a.2.2,0,0,1-.049.256l-.867.659a2.811,2.811,0,0,1,0,.782l.867.662a.2.2,0,0,1,.049.256l-.821,1.384a.205.205,0,0,1-.252.088l-1.022-.4a3.2,3.2,0,0,1-.7.393l-.158,1.061a.2.2,0,0,1-.2.168Zm-.617-4a1.44,1.44,0,1,0,1.441-1.4A1.422,1.422,0,0,0,6210.559,12112Zm-2.49,4H6199a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-.994h16a1,1,0,0,1,.995.994v9.058a1.721,1.721,0,0,0-1.028-.343,1.713,1.713,0,0,1-2.15-1.208h-1.1a.992.992,0,0,0-.718-.3h-2a1,1,0,0,0-1,1v.854a1.758,1.758,0,0,0-.444.5l-.815,1.371a7.846,7.846,0,0,1-.021,4.12l.836,1.408a1.682,1.682,0,0,0,.514.548l0,0Zm-6.069-8.8v3.8a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-3.8a1,1,0,0,0-1-1h-2A1,1,0,0,0,6202,12107.2Zm0-4.3a.9.9,0,0,0,.9.9h8.2a.9.9,0,0,0,0-1.8h-8.2A.9.9,0,0,0,6202,12102.9Z",
    transform: "translate(-6198 -12097.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSettingActive);
export default __webpack_public_path__ + "static/media/SystemSetting_active.fd180979bbbe72f9b636de401bda9b8d.svg";
export { ForwardRef as ReactComponent };